<script lang='ts'>
  import * as _ from 'lodash'
  import HeaderAndLogo from '../Components/Editor/HeaderAndLogo.svelte';
  import FeaturedProductWrapper from '../Components/Editor/FeaturedProductWrapper.svelte';
  import FeaturedItems from '../Components/Editor/FeaturedItems.svelte';
  import Collections from '../Components/Editor/Collections.svelte';
  import ProductCatalog from '../Components/Editor/ProductCatalog.svelte';
  import Footer from '../Components/Editor/Footer.svelte';
  import SectionLink from '../Components/SectionLink.svelte';
  import type { Storefront } from '@shared/types/Storefront';
  export let callbacks: any;
  export let storefront : Storefront;
  let activeSection:string;

  function addCollection() {
    storefront.storefront_collections_attributes = _.concat(storefront.storefront_collections_attributes,
      {
        title: '',
        enabled: true,
        storefront_product_cards_attributes: [],
        position: 0,  // Required for type
      }
    )
    callbacks.update({
      id: storefront.id,
      storefront_collections_attributes: storefront.storefront_collections_attributes
    });
    let scroller = document.getElementById('storefronts-left-pane-scroller')
    if (scroller) {
      localStorage.setItem('lastCollectionModified', `${scroller.scrollTop + 500}`)
    }
  }

  function addAlternative(featuredProductType:string) {
    let newFp = [];
    if (featuredProductType == 'featured') {
      newFp = [{orientation: 'featured'}]
    } else {
      newFp = [{orientation: 'left'}, {orientation: 'right'}]
    }

    storefront.storefront_featured_products_attributes = _.concat(storefront.storefront_featured_products_attributes,
      newFp
    )
  }

  $: activeSection = null;

  callbacks.setActiveSection = function(section : string) {
    activeSection = section;
  };

  const sectionMappings : { title: string; component: object, enableProp?: string, domId: string }[] = [
    {title: 'Header & Logo', component: HeaderAndLogo, domId: 'header_and_logo'},
    {title: 'Featured Product', component: FeaturedProductWrapper, enableProp: 'enable_featured_product', domId: 'featured_product_featured'},
    {title: 'Product Pair', component: FeaturedItems, enableProp: 'enable_featured_items', domId: 'featured_items'},
    {title: 'Product Collections', component: Collections, domId: 'collections'},
    {title: 'Product Catalog', component: ProductCatalog, enableProp: 'enable_catalog', domId: 'product_catalog'},
    {title: 'Footer', component: Footer, domId: 'storefront_footer'}
  ];
</script>

<nav class="fizz-scroller" id='storefronts-left-pane-scroller'>
  <dl class="fizz-toggle-menu">
    {#each sectionMappings as section}
      <SectionLink bind:activeSection title={section.title} domId={section.domId}
        {storefront} {callbacks} enableProp={section.enableProp}>
        <svelte:component this={section.component} {callbacks} {storefront} />
      </SectionLink>
    {/each}
  </dl>
  {#if activeSection == 'Product Collections'}
    <a href={'#'} on:click|preventDefault={addCollection} class='fizz-button-text'>
      Add Collection
    </a>
  {/if}
</nav>
